import { useState } from 'react';

const STORAGE_KEY = 'review-description-dismissed';

export function ReviewDescription() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(STORAGE_KEY) === '1');

  if (dismissed) return null;

  return (
    <div className="review-description">
      <div className="review-description-text">
        Review matches extracted components against the client BoQ (LV).
        {' '}<strong>Collect</strong> source files
        {' '}&rarr; <strong>Group</strong> to deduplicate
        {' '}&rarr; <strong>Match</strong> against LV positions
        {' '}&rarr; <strong>Publish</strong>.
        {' '}Click any row to see its source drawing.
      </div>
      <button
        className="review-description-close"
        onClick={() => { localStorage.setItem(STORAGE_KEY, '1'); setDismissed(true); }}
        title="Dismiss"
      >&times;</button>
    </div>
  );
}
